module.exports = __webpack_public_path__ + "static/media/handxray.78f26d86.png";